import Addresses from './pages/Addresses'
import CartUpdate from './components/CartUpdate'
import ChangeClass from './components/ChangeClass'
import Countdown from './components/Countdown'
import Login from './pages/Login'
import NativeAppPrompt from './components/NativeAppPrompt'
import ObjectFit from './components/ObjectFit'
import pageContext from 'salvo-lite/context'
import Preload from './components/Preload'
import Product from './pages/Product'
import ScrollClass from './components/ScrollClass'
import Select from './components/Select'
import Slick from './components/Slick'
import Slide from './components/Slide'
import Sticky from './components/Sticky'
import Variant from './components/Variant'
import Video from './components/Video'
import Scheduler from './components/Scheduler'

const components = {
    'cart-update': CartUpdate,
    'change-class': ChangeClass,
    'countdown': Countdown,
    'native-app-prompt': NativeAppPrompt,
    'object-fit': ObjectFit,
    'preloader': Preload,
    'scheduler': Scheduler,
    'scroll-class': ScrollClass,
    'select': Select,
    'slick': Slick,
    'slide': Slide,
    'sticky': Sticky,
    'variant': Variant,
    'video': Video
}

const pages = {
    'customers/addresses': Addresses,
    'customers/login': Login,
    'product': Product
}

if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach
}

class Theme {
    constructor () {
        this._components = []
        this._componentsById = {}
    }

    registerComponents (container = document) {
        for (let key in components) {
            var ComponentConstructor = components[key]
            var elements = container.querySelectorAll(`.js-component__${key}, [data-${key}]`)
            for (let elem of elements) {
                var instance = new ComponentConstructor(this, elem)
                this._components.push(instance)
                var id = elem.dataset.componentId
                if (id) {
                    this._componentsById[id] = instance
                }
                instance.onInit()
            }
        }
        window.ThemeComponents = this._components
        window.ThemeComponentsId = this._componentsById
        window.__Theme = this
    }

    registerPages () {
        var context = pageContext.getTemplate()
        for (let page in pages) {
            if (page === context) {
                var instance = new pages[page](this)
                instance.onInit()
            }
        }
    }

    getComponents () {
        return this._components
    }

    getComponentsById (id) {
        return this._componentsById[id]
    }

    getComponentsByType (componentConst, includeSubclasses = true) {
        var r = []
        for (let c of this._components) {
            if (includeSubclasses && c instanceof componentConst) {
                r.push(c)
            } else if (c.constructor === componentConst) {
                r.push(c)
            }
        }
        return r
    }
}

export default Theme



// WEBPACK FOOTER //
// ./src/resources/scripts/Theme.js